import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import FilesListItem from './FilesListItem';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;

const FilesList = ({ items, onDownload }) => (
  <StyledContainer>
    {items?.map(({ id, ...restProps }) => (
      <FilesListItem key={id} id={id} {...restProps} onDownload={onDownload} />
    ))}
  </StyledContainer>
);

FilesList.propTypes = {
  items: PropTypes.array,
  onDownload: PropTypes.func,
};

export default FilesList;
